module.exports = __webpack_public_path__ + "img/notify_danger.a3b75eb5.svg";